import React from 'react';
import { Navigate, Outlet } from 'react-router-dom';

const ProtectedRoute = ({ publicPage = false }) => {
  const token = localStorage.getItem('token');

  if (publicPage && token) {
    return <Navigate to="/" replace />;
  }

  if (!publicPage && !token) {
    return <Navigate to="/login" replace />;
  }

  return <Outlet />;
};

export default ProtectedRoute;